<template>

</template>


<script>

export default {
    components: {
    },
    data () {
        return {
            orders: [],
            pagination: {},
            shipped: [],
            integrations: []
        };
    },
    created() {
        
        let tt = this;

        axios.get('/auth/check')
            .then(function(response){
                if(response.data.status == 'guest') {
                    tt.$router.push('/auth/login');
                }
            }).catch(function(){
        });

        //this.fetchOrders();
        //this.fetchIntegrations();
    },
    mounted() {
        
    },
    methods: {
        fetchIntegrations: function (page_url = '/integrations?ajax=true') {
            let vm = this;
            axios.get(page_url)
                .then(function (response) {
                    if(response.data.length < 1)
                    {
                        $('#myModal').modal('show');
                    };
                });
        },
        fetchOrders: function (page_url = '/orders?ajax=true') {
            let vm = this;
            axios.get(page_url)
                .then(function (response) {
                    vm.makePagination(response.data)
                    vm.orders = response.data.data;
                });
        },
        makePagination: function (data) {
            this.pagination = {
                current_page: data.current_page,
                last_page: data.last_page,
                next_page_url: data.next_page_url,
                prev_page_url: data.prev_page_url
            };
        },
        sync: function(e) {
            let methods = this;
            axios.get('/sync')
                .then(function (response) {
                    methods.fetchOrders();
                });
        }
    }
}
</script>

<style lang="scss" scoped>
    #myModal { 
        .modal-dialog {
            -webkit-transform: translate(0, 80%);
            transform: translate(0px, 80%);
        }
        .modal-content{
            border: 5px solid #fabb3d;
            border-radius: 5px;
            padding: 10px;
            font-size: 25px;
            text-align: center;
            .modal-header{
                background: #f5f5f5;
            }
            .modal-title{
                margin: auto;
                text-align: center;
                font-size: 30px;
                color: #3da3fa;
            }
            .close{
                text-align: right;
                position: absolute;
                top: -15px;
                right: -15px;
                background: #3da3fb;
                opacity: 1;
                color: #fff;
                padding: 3px 8px 8px;
                border-radius: 16px;
                font-size: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/Dashboard.vue